import type { CccdTeamStatus } from '@/lib/api/cccdAdminClient';
import type { DataTableSort } from '@/components/ui/table/DataTable';

// Fuente única de labels/orden de estado de equipo — usada por
// TeamDetailPage, EventDetailPage y RegionalDetailPage para que el filtro
// y las etiquetas se vean idénticos en nacional y regional.
export const TEAM_STATUS_LABELS: Record<CccdTeamStatus, string> = {
  draft: 'Borrador',
  negotiating: 'Negociación',
  payment_pending: 'Pago pendiente',
  active: 'Activo',
  inactive: 'Inactivo',
  rejected: 'Rechazado',
};

export const TEAM_STATUS_FILTERS: Array<CccdTeamStatus | 'all'> = [
  'all',
  'draft',
  'payment_pending',
  'active',
  'inactive',
  'rejected',
];

export const TEAM_STATUS_FILTER_LABELS: Record<CccdTeamStatus | 'all', string> = {
  all: 'Todos',
  ...TEAM_STATUS_LABELS,
};

// Misma paginación y orden en toda tabla de equipos (TeamsListCard, usada por
// EventDetailPage y RegionalDetailPage) — antes cada página lo reimplementaba
// por su cuenta y una de las dos terminó sin paginación real.
export const TEAMS_PAGE_SIZE = 20;

type SortableTeam = { name: string; status: string; createdAt: string };

export function sortTeams<T extends SortableTeam>(teams: T[], sort: DataTableSort): T[] {
  if (!sort) return teams;
  const dir = sort.dir === 'asc' ? 1 : -1;
  return [...teams].sort((a, b) => {
    if (sort.column === 'name') return dir * a.name.localeCompare(b.name);
    if (sort.column === 'status') return dir * a.status.localeCompare(b.status);
    if (sort.column === 'createdAt') return dir * (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
    return 0;
  });
}
